<template>
  <div id="application-header">
    <img id="header-logo" :src="logo" alt="" />
  </div>
</template>
<script>
export default {
  computed: {
    logo() {
      return this.$store.getters.businessLogo;
    },
  },
};
</script>
<style scoped>
@media screen {
  #application-header {
    position: absolute;
    top: 0;
    left: 0;
    height: 100px;
    padding: 12.5px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
  }
  #header-logo {
    max-width: 40%;
    height: 75%;
  }
  @media (max-width: 800px) {
    #application-header {
      height: 100px;
    }
    #header-logo {
      max-width: 40%;
      height: 75%;
    }
  }
  @media (min-width: 800px) {
    #application-header {
      height: 125px;
      padding: 40px;
    }
    #header-logo {
      height: 100%;
    }
  }
}

@media print {
  #application-header {
    display: none;
  }
}
</style>
